import { Wrench, ShoppingBag, Home, Users } from "lucide-react";

const AUDIENCES = [
  {
    icon: Wrench,
    tag: "Home Services",
    title: "Trades, installers, cleaners, local services",
    body: "Book-rate drops when leads don't get a fast reply. We tighten inbound response, after-hours coverage and quote follow-up.",
  },
  {
    icon: ShoppingBag,
    tag: "Ecommerce",
    title: "DTC brands doing real volume",
    body: "Weak follow-up, abandoned flows and support pile-ups quietly kill conversion. We map the leaks and fix the ones that matter.",
  },
  {
    icon: Home,
    tag: "Real Estate",
    title: "Agents, brokerages, property managers",
    body: "Admin, listings, tenant comms and lead qualification eat hours. We automate the repetitive and sharpen response time.",
  },
  {
    icon: Users,
    tag: "Ops-Heavy Small Teams",
    title: "Small teams stuck in spreadsheets",
    body: "If your ops run on 'ask Sarah' and a shared Google Sheet, we rebuild the workflow so the business doesn't depend on one person.",
  },
];

export default function WhoItsFor() {
  return (
    <section
      id="who"
      className="bg-[#FAFAFA] border-b border-zinc-200"
      data-testid="who-section"
    >
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12 py-24 sm:py-32">
        <div className="max-w-3xl reveal">
          <div className="flex items-center gap-3">
            <span className="inline-block h-px w-10 bg-orange-600" />
            <span className="font-mono text-xs uppercase tracking-[0.22em] text-orange-600 font-semibold">
              Who It's For
            </span>
          </div>
          <h2 className="mt-6 font-display font-bold text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight text-zinc-950">
            Built for owners — not enterprises.
          </h2>
          <p className="mt-6 text-lg text-zinc-600 leading-relaxed">
            If you're running a growing business and the operational mess is starting to tax
            you personally, this is the right starting point.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-px bg-zinc-200 border border-zinc-200">
          {AUDIENCES.map((a, i) => {
            const Icon = a.icon;
            return (
              <div
                key={a.tag}
                className="group bg-white p-8 transition-all duration-300 hover:bg-zinc-950 hover:text-white reveal"
                data-testid={`audience-${i}`}
              >
                <Icon
                  size={24}
                  className="text-zinc-900 group-hover:text-orange-500 transition-colors"
                />
                <div className="mt-6 font-mono text-[11px] uppercase tracking-[0.22em] text-orange-600 group-hover:text-orange-500">
                  {a.tag}
                </div>
                <h3 className="mt-3 font-display font-semibold text-xl tracking-tight text-zinc-950 group-hover:text-white">
                  {a.title}
                </h3>
                <p className="mt-3 text-sm text-zinc-600 group-hover:text-zinc-300 leading-relaxed">
                  {a.body}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
